// src/pages/Auth/ForgotPassword.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { authService } from '../../services/authService';
import { COLORS } from '../../utils/constants';
import './ForgotPassword.css';

const ForgotPassword = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await authService.forgotPassword(email);
      setSubmitted(true);
    } catch (err) {
      setError(err.message || 'Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="forgot-password-container">
      <div className="forgot-password-card">
        {/* Logo */}
        <div className="forgot-password-logo">🔑</div>

        <h2>Forgot Password?</h2>

        {!submitted ? (
          <>
            <p className="forgot-password-subtitle">
              Enter the email address linked to your account and we'll send you a reset link.
            </p>

            {error && (
              <div className="forgot-password-error">
                {error}
              </div>
            )}

            <form onSubmit={handleSubmit} className="forgot-password-form">
              <div className="form-group">
                <label htmlFor="email">Email Address</label>
                <input
                  type="email"
                  id="email"
                  value={email}
                  onChange={(e) => {
                    setEmail(e.target.value);
                    setError('');
                  }}
                  placeholder="your.email@example.com"
                  required
                  disabled={loading}
                  autoFocus
                />
              </div>

              <button
                type="submit"
                className="forgot-password-btn"
                disabled={loading || !email}
                style={{ backgroundColor: loading || !email ? '#ccc' : COLORS.PRIMARY }}
              >
                {loading ? 'Sending...' : 'Send Reset Link'}
              </button>
            </form>
          </>
        ) : (
          <div className="forgot-password-success">
            <div className="success-icon">✓</div>
            <p className="success-title">Check Your Inbox</p>
            <p className="success-message">
              If an account exists for <strong>{email}</strong>, a password reset link has been sent.
              The link expires in <strong>1 hour</strong>.
            </p>
            <p className="success-note">
              Didn't receive it? Check your spam folder or{' '}
              <button
                className="resend-link"
                onClick={() => {
                  setSubmitted(false);
                  setEmail('');
                }}
                style={{ color: COLORS.PRIMARY }}
              >
                try a different email
              </button>.
            </p>
          </div>
        )}

        <div className="forgot-password-footer">
          <button
            className="back-to-login"
            onClick={() => navigate('/')}
            style={{ color: COLORS.PRIMARY }}
          >
            ← Back to Login
          </button>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;